<template>
	<div class="dialogBox">
		<ul>
			<li>
				<p>渠道：</p>
				<select v-model="pData.channel">
					<option value="0">其他</option>
					<option value="1">旅责险</option>
					<option value="2">AA华助</option>
				</select>
				<input type="text" placeholder="请输入其他渠道名称" v-model="pData.other"/>
			</li>
			<li>
				<div>
					<p>用户手机号：</p>
					<input type="text" placeholder="请输入手机号" v-model="pData.mobileNo"/>
				</div>
				<div class="margint10">
					<p>用户姓名：</p>
					<input type="text" placeholder="请输入用户名" v-model="pData.realName"/>
				</div>
			</li>
			<li class="all">
				<div>
					<p>用户证件号：</p>
					<input type="text" placeholder="请输入用户证件号" v-model="pData.nationalId"/>					
				</div>
			</li>
			<li class="yanzheng">
				<div class="width1">
					<p>星使ID：</p>
					<input type="text" placeholder="请输入星使ID" v-model="pData.targetUserId"/>					
				</div>
				<div>
					<button type="button" @click="getSearchUser">验证ID</button>
				</div>
			</li>
			<li>
				<div>
					<p>星使姓名：</p>
					<input type="text" placeholder="请输入星使姓名" v-model="xsName" disabled="disabled"/>
				</div>
				<div class="margint10">
					<p>星使性别：</p>
					<select v-model="xsXb" disabled="disabled">
						<option value="1">男</option>
						<option value="2">女</option>
					</select>
				</div>
			</li>
			<h3 style="line-height: 40px;"><center>订单信息</center></h3>
			<li>
				<p>服务国家：</p>				
				<input class="fan" type="text" placeholder="请输入服务国家拼音" v-model="pData.country" @input="searchCountry"/>
				<select v-model="pData.countryCode">
					<option v-for="item in countryList" :value="item.country.countryCode">{{item.country.countryName}}</option>
				</select>
			</li>
			<li class="yanzheng">
				<div class="width1">
					<p>服务所在地：</p>
					<input type="text" placeholder="请输入服务所在地" v-model="pData.addr"/>					
				</div>
				<div>
					<button type="button" @click="getSearchAddr">查询</button>
				</div>
			</li>
			<li>
				<div>
					<p>经度：</p>
					<input type="text" placeholder="请输入经度" v-model="pData.lng" disabled="disabled"/>
				</div>
				<div class="margint10">
					<p>纬度：</p>
					<input type="text" placeholder="请输入纬度" v-model="pData.lat" disabled="disabled"/>
				</div>
			</li>			
			<li class="all">
				<div>
					<p>星使接单时间：</p>		
					<el-date-picker v-model="pData.fetchAt" type="datetime" placeholder="选择日期时间"></el-date-picker>
				</div>				
			</li>
			<li class="all">
				<div>
					<p>服务开始时间：</p>		
					<el-date-picker v-model="pData.startAt" type="datetime" placeholder="选择日期时间"></el-date-picker>
				</div>				
			</li>
			<li>
				<div>
					<p>服务时长：</p>
					<input type="text" placeholder="请输入服务时长" v-model="pData.hour"/>
				</div>
				<div class="margint10">
					<p>服务单价：</p>
					<input type="text" placeholder="请输入服务单价" v-model="pData.price"/>
				</div>
			</li>	
			<li class="all">
				<div>
					<p>客户需求留言：</p>
					<input type="text" placeholder="请输入客户需求留言" v-model="pData.textMsg"/>					
				</div>
			</li>			
			<h3 style="line-height: 40px;"><center>增值费用 <span @click="addList" style="color: #00abfa;"> +增加一项增值服务</span></center></h3>
			<li v-for="item in valuelst">
				<div>
					<p>费用说明：</p>
					<input type="text" placeholder="请输入服务说明" v-model="item.title"/>
				</div>
				<div class="margint10">
					<p>服务单价：</p>
					<input type="text" placeholder="请输入服务单价" v-model="item.cost"/>
				</div>
			</li>				
		</ul>
		<div class="btn">
			<button type="button" @click="getAddxingshi">提交</button>
		</div>
	</div>
</template>

<script>
	import { getAddxingshi,getSearchUser,getlistByContinent,getSearchAddr } from '@/views/axios/api.js';
	export default{
		data(){
			return {
				value1:'',
				value2:'',
				pData:{
					token:JSON.parse(window.localStorage.getItem("data")).data,
					caseId:'',
					mobileNo:'',
					nationalId:'',
					realName:'',
					channel:'',
					other:'',
					targetUserId:'',
					countryCode:'',
					country:'',
					fetchAt:'',
					startAt:'',
					hour:'',
					price:'',
					textMsg:'',
					addr:'',
					lat:'',
					lng:'',
					valuelst:'',
					iso3166:3166
				},
				xsName:'',
				xsXb:'',
				countryList:[],
				valuelst:[
					{title:'',cost:''}
				]				
			}
		},
		props:['caseId'],
		mounted(){
			this.getlistByContinent()
		},
		methods:{
			getAddxingshi(){
				if(this.pData.channel == '') return this.$message.error('请选择渠道！');
				if(this.pData.channel == 0 && this.pData.other == '') return this.$message.error('请输入其他渠道渠道！');
				if(this.pData.mobileNo == '') return this.$message.error('请输入用户手机号码！');
				if(this.pData.realName == '') return this.$message.error('请输入用户姓名！');
				if(this.pData.nationalId == '') return this.$message.error('请输入用户证件号！');
				if(this.pData.targetUserId == '') return this.$message.error('请输入星使ID！');
				if(this.pData.addr == '') return this.$message.error('请输入服务所在地！');
				if(this.pData.fetchAt == '') return this.$message.error('请输入接单时间！');
				if(this.pData.startAt == '') return this.$message.error('请输入服务开始时间！');
				if(this.pData.hour == '') return this.$message.error('请输入服务时长！');
				if(this.pData.price == '') return this.$message.error('请输入服务服务单价！');
				this.pData.caseId=this.caseId;
				this.pData.fetchAt= new Date(this.pData.fetchAt).getTime();
				this.pData.startAt= new Date(this.pData.startAt).getTime();
				this.pData.valuelst=JSON.stringify(this.valuelst)
				getAddxingshi(this.pData)
				.then(res => {
					if(res.data.code == 0){
				        this.$message({
				          message: '星使添加成功',
				          type: 'success'
				        });
						this.$emit('dialogBox')
					}else{
						this.$message.error('添加失败，请刷新重试！')
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			getSearchUser(){//查询星使ID
				if(this.pData.targetUserId == '') return this.$message.error('查询ID不能为空');
				var data={
					token:this.pData.token,
					userId:this.pData.targetUserId,
					isProvider:1
				}
				getSearchUser(data)
				.then(res => {
					var data=res.data.obj
					if(!data) return this.$message.error('找不到该id');
					this.xsName=data.realName;
					this.xsXb=data.gender;
				})
				.catch(err => {
					console.log(err)
				})				
			},
			addList(){
				this.valuelst.push({title:'',cost:''})
			},
			getlistByContinent(){
				getlistByContinent()
				.then(res => {
					this.countryList=res.data.obj
				})
				.catch(err => {
					console.log(err)
				})				
			},
			searchCountry(){//查询国家
				var arr= this.countryList.find(item => {
					return item.country.pinyin == this.pData.country;
				})
				if(arr){
					this.pData.countryCode=arr.country.countryCode;
					this.pData.iso3166=arr.country.iso3166
				}				
			},
			getSearchAddr(){//查询地址
				var data={
					token:this.pData.token,
					hit:this.pData.addr
				}
				getSearchAddr(data)
				.then(res => {					
					var data=res.data.obj;
					if(!data) return this.$message.error('找不到该地址');
					this.pData.lat=data.latitude;
					this.pData.lng=data.longitude;					
				})
				.catch(err => {
					console.log(err)
				})				
			}
		}
	}
</script>

<style scoped="scoped">
	*{outline: none;}
	.dialogBox{padding: 0 30px;}
	.dialogBox li{overflow: hidden;margin-bottom: 10px;}
	.dialogBox li >*{float: left;}
	.dialogBox li p{width:100px;line-height: 40px;color: #333;text-align: right;}
	.dialogBox li select{width:210px;border: 1px solid #d9ddde;height: 40px;border-radius: 3px;}
	.dialogBox li input{width:280px;border: 1px solid #d9ddde;height: 38px;border-radius: 3px;padding-left: 10px;margin-left: 31px;}
	.dialogBox li div{overflow: hidden;}
	.dialogBox li div >*{float: left;}
	.dialogBox li div >input{width: 200px;margin-left: 0;}
	.margint10{margin-left: 10px;}
	.dialogBox li.all input{width: 522px !important;}
	.dialogBox li .width1 input{width: 400px;}
	.dialogBox li div button{border: none;width: 100px;height: 40px;background-color: #00abf9;color: white;border-radius: 3px;margin-left: 20px;}
	.dialogBox li .fan{margin-left: 0; margin-right: 30px;}
	.btn{text-align: center;margin-top: 20px;}
	.btn button{width: 150px;height: 40px;background: #00abf9;color: white;border: none;}
	button{cursor: pointer;}
</style>


// WEBPACK FOOTER //
// src/views/commonPage/dialog.vue